import {target} from '../utils/dom';

document.queryAll('[data-catalog]').forEach(init);

document.addEventListener('change', onChange);

function init(el) {
	const images = JSON.parse(el.getAttribute('data-catalog'));
	if (images.length <= 0) {
		return;
	}
	const figure = el.query('figure');
	let promises = [];

	images.forEach((src, index) => {
		let promise = new Promise((resolve, reject) => {
			let img = new Image();
			img.onload = () => resolve();
			img.onerror = () => reject();
			img.setAttribute('data-index', index + 1);
			img.src = src;
			figure.appendChild(img);
		});
		promises.push(promise);
	});

	Promise.all(promises).then(() => launch(figure));
}

function launch(el) {
	let images = el.queryAll('img');
	el.addEventListener('mousemove', event => onMove(event, el, images));
	el.addEventListener('mouseout', () => {
		let active = el.query('img.active');
		active.classList.remove('active');
		el.query('[data-index="0"]').classList.add('active');
	});
}

function onMove(event, el, images) {
	let elWidth = el.offsetWidth;
	let width = elWidth / images.length - 2;
	let active = el.query('img.active');
	for (let i = images.length - 2; i >= 0; i--) {
		if (event.offsetX > width * i) {
			let img = el.query(`[data-index="${i + 1}"]`);
			if (active && active !== img) {
				active.classList.remove('active');
				img.classList.add('active');
			}
			break;
		}
	}
}

function onChange(event) {
	let catalog = target(event.target, '[name*="catalogs"]');
	if (catalog) {
		synchCheck(catalog);
	}
}

function synchCheck(elt) {
	let name = elt.getAttribute('value');
	let checked = elt.checked;
	let checkboxes = document.queryAll(`[value="${name}"]`);
	if (checkboxes) {
		checkboxes.forEach((item) => {
			if (item === elt) {
				return;
			}
			item.checked = checked;
		});
	}
}
